import { ProfileMenu } from '../ProfileMenu';

import { ActionsRow, MenuContainer } from './ProfileHeaderActions.styled';

/**
 * Header actions row: the profile's buttons followed by the ⋮ menu. Wraps right-aligned
 * when the actions column is too narrow.
 * @param {Object} props
 * @param {React.ReactNode} [props.children] Buttons shown before the menu
 * @param {Array} props.menuItems Passed to ProfileMenu
 */
export const ProfileHeaderActions = ({ children, menuItems }) => (
  <ActionsRow>
    {children}
    <MenuContainer>
      <ProfileMenu items={menuItems} />
    </MenuContainer>
  </ActionsRow>
);
